import { Box, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'

import { BasePermissionsForm } from '../index'

import constants from 'constants/index'

const AdvisorPermissionsForm = ({
  permissions,
  handleChange,
  activeProfile,
  isEdit,
}) => {
  const { register } = useFormContext()

  const { advisorProfileLists } = constants.permissionsLists

  return (
    <>
      <Box mt={2} mb={3}>
        <Typography variant="h5">Permissões</Typography>
      </Box>
      <BasePermissionsForm
        title="Enquadramento Legal"
        permissionsList={advisorProfileLists.legalFrameworkList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Empresas"
        permissionsList={advisorProfileLists.organizationCompanyList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Questionários"
        permissionsList={advisorProfileLists.questionnaireList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Classificadores"
        permissionsList={advisorProfileLists.tagList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
        noOverFlow
      />
      <BasePermissionsForm
        title="Atendimento ao Titular"
        permissionsList={advisorProfileLists.juridicTicketList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Configuração do Canal de Atendimento"
        permissionsList={advisorProfileLists.privacyPortalConfigurationList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Grupo Advisor"
        permissionsList={advisorProfileLists.organizationList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Perfis de Usuário"
        permissionsList={advisorProfileLists.profileList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Incidentes"
        permissionsList={advisorProfileLists.incidentList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
        noOverFlow
      />
      <BasePermissionsForm
        title="Solicitações"
        permissionsList={advisorProfileLists.solicitationTicketList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
        noOverFlow
      />
      <BasePermissionsForm
        title="Atividades"
        permissionsList={advisorProfileLists.taskList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Legítimo Interesse"
        permissionsList={advisorProfileLists.legitimateInterestList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
        noOverFlow
      />
      <BasePermissionsForm
        title="Modelos de Processos"
        permissionsList={advisorProfileLists.dataProcessTemplateList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Documentos Modelo"
        permissionsList={advisorProfileLists.documentTemplateList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Privacy By Design"
        permissionsList={advisorProfileLists.privacyByDesignList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
    </>
  )
}

AdvisorPermissionsForm.propTypes = {
  register: PropTypes.func,
  permissions: PropTypes.object,
  handleChange: PropTypes.func,
  activeProfile: PropTypes.bool,
  isEdit: PropTypes.bool,
}

export default AdvisorPermissionsForm
